import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DxItem = _resolveComponent("DxItem");
    const _component_DxToolbar = _resolveComponent("DxToolbar");
    const _component_DxMediaResizing = _resolveComponent("DxMediaResizing");
    const _component_DxHtmlEditor = _resolveComponent("DxHtmlEditor");
    const _component_g_field_block = _resolveComponent("g-field-block");
    return (_openBlock(), _createBlock(_component_g_field_block, _mergeProps(_ctx.$attrs, {
        name: _ctx.dataMember,
        "is-auto-fill": _ctx.isAutoFill,
        "error-message": _ctx.errorMessage,
        label: _ctx.label
    }), {
        "g-field-input": _withCtx(({ identification, error, disabled, size, setFocusClass, removeFocusClass, hasSuffix, hasPrefix }) => [
            _createVNode(_component_DxHtmlEditor, {
                height: "100%",
                value: _ctx.internalValue
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_DxToolbar, { multiline: true }, {
                        default: _withCtx(() => [
                            _createVNode(_component_DxItem, { name: "undo" }),
                            _createVNode(_component_DxItem, { name: "redo" }),
                            _createVNode(_component_DxItem, { name: "separator" }),
                            _createVNode(_component_DxItem, {
                                name: "size",
                                "accepted-values": ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt']
                            }),
                            _createVNode(_component_DxItem, {
                                name: "header",
                                "accepted-values": [false, 1, 2, 3, 4, 5]
                            }),
                            _createVNode(_component_DxItem, { name: "separator" }),
                            _createVNode(_component_DxItem, { name: "bold" }),
                            _createVNode(_component_DxItem, { name: "italic" }),
                            _createVNode(_component_DxItem, { name: "strike" }),
                            _createVNode(_component_DxItem, { name: "underline" }),
                            _createVNode(_component_DxItem, { name: "separator" }),
                            _createVNode(_component_DxItem, { name: "alignLeft" }),
                            _createVNode(_component_DxItem, { name: "alignCenter" }),
                            _createVNode(_component_DxItem, { name: "alignRight" }),
                            _createVNode(_component_DxItem, { name: "alignJustify" }),
                            _createVNode(_component_DxItem, { name: "separator" }),
                            _createVNode(_component_DxItem, { name: "orderedList" }),
                            _createVNode(_component_DxItem, { name: "bulletList" }),
                            _createVNode(_component_DxItem, { name: "color" }),
                            _createVNode(_component_DxItem, { name: "background" }),
                            _createVNode(_component_DxItem, { name: "separator" }),
                            _createVNode(_component_DxItem, { name: "link" }),
                            _createVNode(_component_DxItem, { name: "image" }),
                            _createVNode(_component_DxItem, { name: "separator" }),
                            _createVNode(_component_DxItem, { name: "clear" }),
                            _createVNode(_component_DxItem, { name: "codeBlock" }),
                            _createVNode(_component_DxItem, { name: "blockquote" }),
                            _createVNode(_component_DxItem, { name: "separator" }),
                            _createVNode(_component_DxItem, { name: "insertTable" }),
                            _createVNode(_component_DxItem, { name: "deleteTable" }),
                            _createVNode(_component_DxItem, { name: "insertRowAbove" }),
                            _createVNode(_component_DxItem, { name: "insertRowBelow" }),
                            _createVNode(_component_DxItem, { name: "deleteRow" }),
                            _createVNode(_component_DxItem, { name: "insertColumnLeft" }),
                            _createVNode(_component_DxItem, { name: "insertColumnRight" }),
                            _createVNode(_component_DxItem, { name: "deleteColumn" }),
                            _createVNode(_component_DxItem, { name: "cellProperties" }),
                            _createVNode(_component_DxItem, { name: "tableProperties" })
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_DxMediaResizing, { enabled: true })
                ]),
                _: 1
            }, 8, ["value"])
        ]),
        _: 1
    }, 16, ["name", "is-auto-fill", "error-message", "label"]));
}
